<template>
  <div class="meeting-owner-panel" data-testid="meeting-owner-side-panel">
    <!-- useUrlFragment must stay off: the viewer's bottom tabs own the URL hash. -->
    <Tabs selected-tab="#meeting" :options="{ useUrlFragment: false }">
      <Tab id="ai" name="AI Actions" class="meeting-owner-panel__panel">
        <component :is="aiPanel" />
      </Tab>
      <Tab id="meeting" name="Meeting Details" class="meeting-owner-panel__panel">
        <MeetingDetails />
      </Tab>
    </Tabs>
  </div>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue';
import { Tabs, Tab } from '@/storybook';

import MeetingDetails from './MeetingDetails.vue';
import SmartActionsSidePanel from '@/modules/viewer/components/SmartActionsSidePanel.vue';
import SmartActionsUpsell from '@/modules/viewer/components/SmartActionsUpsell.vue';
import { useVideoAi } from '@/modules/viewer/composables/useVideoAi';

const { hasAiAddon } = useVideoAi();

const aiPanel = computed<Component>(() => (hasAiAddon.value ? SmartActionsSidePanel : SmartActionsUpsell));
</script>

<style scoped>
.meeting-owner-panel {
  @apply flex flex-col w-full px-4 pt-2 pb-3 bg-white dark:bg-zinc-800 rounded-xl border border-zinc-200 dark:border-zinc-700;
}

/* The smart actions panel carries its own card chrome; flatten it inside this card. */
.meeting-owner-panel :deep(.smart-actions-panel) {
  @apply border-0 rounded-none bg-transparent;
}
</style>
